import { Injector } from "@angular/core";
import { ListView } from "../../../Data/ListView";
import { Art57Node } from "../Art57Node";
import { Art57NodeList } from "../Art57NodeList";
import { TreeNodeMedicalDevice } from "../Entity/TreeNodeMedicalDevice";
import { environment } from "../../../../../../environments/environment";

export class TreeNodeMedicalDeviceList extends Art57NodeList {
    constructor(injector: Injector, parent: Art57Node) {
      super(injector, new ListView(), 'Medical Devices ({param})');
      this.labelNodeName = 'Medical Devices';
      this.parent = parent;
    }
  
    override refreshLabel(): void {
      this.label = this.labelTemplate.replace(
        '{param}',
        this.getLabelParamFromChildren()
      );
    }
  
    override createChildTemplate(): Art57Node[] | null {
      let node = new TreeNodeMedicalDevice(this.ioc!, this);
      this.children?.push(node);
  
      this.refreshLabel();
      return [node];
    }
  
    override cloneNode(newParent: Art57Node): Art57Node|undefined {
      let clonedNode: TreeNodeMedicalDeviceList = new TreeNodeMedicalDeviceList(
        this.ioc!,
        newParent
      );
  
      this.children?.forEach((child) => {
        let childToClone = child as Art57Node;
        let clonedChildren = childToClone.cloneNode(clonedNode);
        if (clonedChildren) {
            clonedNode.children?.push(clonedChildren);
            clonedChildren.refreshLabel();
        }
      });
  
      clonedNode.refreshLabel();  
      clonedNode.expanded = this.expanded && (environment.userPreferences.autoexpandNodesOnCloning ||environment.userPreferences.alwaysAutoexpandNodes)

  
      return clonedNode;
    }
  
    override getMessage(): any {
      let medicaldevices: Art57Node[] = [];
      this.children?.forEach((node) => {
        let medicaldevice = node as Art57Node;
        medicaldevices.push(medicaldevice.getMessage());
      });
      if (medicaldevices.length > 0) {
        return { medicaldevices: { medicaldevice: medicaldevices } };
      } else {
        return undefined;
      }
    }
  
    override getHeaders(): string[] {
      return ['Code', 'Medical Device'];
    }
  }